import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private http: HttpClient, private sessionService: SessionService, private catalogueService: CatalogueService,
  private catalogueUserService: CatalogueUserService) { }

  getData() {
    let nameStorage = `profile_${this.catalogueService.getProperty('sapCode')}`;
    return JSON.parse(this.sessionService.get(nameStorage, true))['authorities'] || [];
  }

  hasRoles(roles) {

    let userRoles = this.getData();
    let hasRole = false;

    for (let i = 0; i < roles.length; i++) {
      for (let j = 0; j < userRoles.length; j++) {
        if (userRoles[j].name === roles[i]) {
          hasRole = true;
        }
      }
    }

    return hasRole;

  }
  
  isSingleExhibitor() {
    if (!this.catalogueUserService.getProperty('exhibitorId')) {
      return false;
    } else {
      return this.catalogueUserService.getProperty('exhibitorId').length === 1;
    }
  }

  isMultipleExhibitor() {
    if (!this.catalogueUserService.getProperty('exhibitorId')) {
      return false;
    } else {
      return this.catalogueUserService.getProperty('exhibitorId').length > 1;
    }
  }

  exhibitorCanEdit(exhibitorId) {

    let canEdit = false;
    let exhibitorIds = this.catalogueUserService.getProperty('exhibitorId') || [];

    for (let i = 0; i < exhibitorIds.length; i++) {
      if (exhibitorId == exhibitorIds[i]) {
        canEdit = true;
      }
    }

    return canEdit;

  }

}
